var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-chart',[_c('loading',{attrs:{"active":_vm.loading,"z-index":1000,"is-full-page":false}}),_c('apex-chart',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"height":"175","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }